<template>
  <section id="template">
    <div class="card mx-5 my-5 p-sm-5 border-3 shadow-sm">
      <div class="card-body">
        <article id="page">
          <div id="wlt-BasePage" class="worklet">
            <div class="worklet-info notice hide"></div>
            <div class="worklet-content">
              <h3 class="worklet-title text-center">TÉRMINOS Y CONDICIONES</h3>
              <div class="clearfix">
                <div class="terms-wrapper">
                  <div class="terms-title">Marco Legal</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >&ldquo;Marido-en-alquiler.com&rdquo; es una marca de
                          Target Innovations S.R.L, Sociedad comercial
                          constituida de conformidad con las leyes de la
                          Rep&uacute;blica Dominicana, Con Registro Nacional de
                          Contribuyente No. 1-30-48670-2, Con Domicilio Social
                          en la Calle Paseo de los Locutores No. 45, Edif.
                          Digicolor, Local 2A, Ensanche Evaristo Morales, de
                          esta ciudad de Santo Domingo, Debidamente Representado
                          por el Sr. Sergio Clemente Pichardo de Le&oacute;n,
                          Dominicano, mayor de edad, portador de la
                          c&eacute;dula de identidad y electoral no.
                          001-0000000-0, domiciliado y residente en esta ciudad
                          de Santo Domingo, Distrito Nacional, Rep&uacute;blica
                          Dominicana; se reserva el derecho de cambiar,
                          modificar, adicionar o eliminar total o parcialmente
                          lo contenido en los presentes t&eacute;rminos,
                          notificando a los usuarios en un plazo de quince (15)
                          d&iacute;as calendario, por los medios habituales de
                          marido-en-alquiler.com, tanto en la p&aacute;gina web,
                          correos masivos y redes sociales.</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >Los siguientes t&eacute;rminos de referencia o
                          condiciones de uso de la p&aacute;gina han sido
                          elaborados de conformidad con la Ley No. 358-05 o Ley
                          General de Protecci&oacute;n de los Derechos del
                          Consumidor, a los fines de garantizar a todos nuestros
                          usuarios los derechos que les confiere la referida
                          legislaci&oacute;n y cumplir con los deberes y
                          obligaciones que nos confiere la misma en nuestra
                          condici&oacute;n de intermediario y/o mediador entre
                          el proveedor y usuarios.</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >Queda expresamente convenido que la naturaleza
                          contractual que conlleva el uso de esta p&aacute;gina
                          corresponde a un Contrato de Mediaci&oacute;n o
                          Corretaje mediante el cual
                          &ldquo;Marido-en-alquiler.com&rdquo;, en su calidad de
                          mediador, facilita la aproximaci&oacute;n entre un
                          comprador (el usuario) y un vendedor (el proveedor)
                          percibiendo una remuneraci&oacute;n por ello. En ese
                          sentido, la celebraci&oacute;n del contrato final de
                          compraventa y las consecuencias legales que
                          &eacute;ste conlleva existe &uacute;nicamente entre el
                          proveedor y el usuario, marido-en-alquiler.com se
                          compromete a hacer todas las gestiones de forma
                          solidaria para apoyar al usuario a que reciba el mejor
                          servicio o los productos contratados por via de
                          marido-en-alquiler.com o realizar la devoluci&oacute;n
                          del pago en caso de ser necesario. Todo ello, de
                          conformidad con lo se&ntilde;alado en el Art. 3,
                          numeral &ldquo;l&rdquo; de la Ley 358-05 que define al
                          proveedor como la &ldquo;persona f&iacute;sica o
                          jur&iacute;dica, p&uacute;blica o privada, que
                          habitual u ocasionalmente, produce, importa, manipula,
                          acondiciona, envasa, almacena, distribuye,
                          comercializa o vende productos o presta servicios en
                          el mercado a consumidores o usuarios, incluyendo los
                          servicios profesionales liberales que requieran para
                          su ejercicio un t&iacute;tulo universitario, en lo que
                          concierne a la relaci&oacute;n comercial que conlleva
                          su ejercicio y la publicidad que se haga de su
                          ofrecimiento o cualquier acto
                          equivalente&rdquo;.</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >En ese sentido y de conformidad a lo dispuesto en el
                          Art. 48 de la Ley 358-05, &ldquo;los proveedores son
                          los responsables de la veracidad de la publicidad
                          referente a los productos o servicios que
                          ofrecen&rdquo;, asimismo &eacute;stos son los
                          responsables por los vicios y defectos en los
                          productos y/o servicios que ofrezcan seg&uacute;n lo
                          se&ntilde;ala el Art. 63 de la Ley 358-05 que reza:
                          &ldquo;El proveedor es responsable por la idoneidad y
                          calidad de los bienes y servicios que oferta, vende o
                          presta en el mercado. Un bien o servicio se considera
                          defectuoso, viciado o insuficiente cuando por su
                          naturaleza o condiciones no cumple con el
                          prop&oacute;sito o utilidad para el que estaba
                          destinado, sea diferente a las especificaciones
                          estipuladas por el fabricante o suplidor o disminuya
                          de tal modo su calidad o la posibilidad&rdquo;.</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >&ldquo;Marido-en-alquiler.com&rdquo; y el proveedor
                          est&aacute;n atados bajo un contrato de
                          prestaci&oacute;n de Servicios de Publicidad y
                          Promoci&oacute;n el cual se encuentra regido por las
                          previsiones generales que contemplan los contratos de
                          servicio que se&ntilde;ala el derecho com&uacute;n y
                          la Ley 358-05. Los preceptos de dicho contrato no
                          aprovechan o perjudican al usuario m&aacute;s de lo
                          que se&ntilde;alan los presentes t&eacute;rminos de
                          referencia, en ese sentido, la relaci&oacute;n
                          contractual entre el usuario y
                          &ldquo;Marido-en-alquiler.com&rdquo; se limita
                          &uacute;nica y exclusivamente a los t&eacute;rminos
                          que se&ntilde;alan los presentes
                          t&eacute;rminos.</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >A los fines de ilustrar a los usuarios de la
                          naturaleza contractual del proveedor con
                          &ldquo;Marido-en-alquiler.com&rdquo; se establecen las
                          definiciones de promoci&oacute;n de ventas, publicidad
                          y oferta que contempla el Art. 3 de la Ley
                          358-05:</span
                        >
                      </li>
                      <ol style="list-style-type: lower-alpha">
                        <li style="font-weight: 400" aria-level="3">
                          <span style="font-weight: 400"
                            >Art. 3, literal &ldquo;k&rdquo;- Promoci&oacute;n
                            de ventas: &ldquo;Son actividades o acciones,
                            complementarias a la publicidad, dirigidas a
                            incrementar las ventas, ya sea en puntos de ventas
                            directamente al consumidor, o bien al intermediario
                            y/o al mayorista y que generalmente conllevan
                            ofertas de alg&uacute;n beneficio extra o valor
                            agregado para el sector del p&uacute;blico al que
                            van dirigidas&rdquo;.</span
                          >
                        </li>
                        <li style="font-weight: 400" aria-level="3">
                          <span style="font-weight: 400"
                            >Art. 3, literal &ldquo;m&rdquo;-Publicidad:
                            &ldquo;Es toda forma o medio de comunicaci&oacute;n
                            que directa o indirectamente es realizada por una
                            persona f&iacute;sica o moral, p&uacute;blica o
                            privada, en el ejercicio de una actividad
                            comercial&rdquo;.</span
                          >
                        </li>
                        <li style="font-weight: 400" aria-level="3">
                          <span style="font-weight: 400"
                            >Art. 3, literal &ldquo;i&rdquo;- Oferta: &ldquo;Es
                            la declaraci&oacute;n o manifestaci&oacute;n
                            unilateral de la voluntad hecha p&uacute;blica a
                            personas determinadas o indeterminadas, por parte
                            del fabricante industrial, distribuidor, proveedor y
                            comerciante de ventas, de ceder, vender, alquilar o
                            prestar un determinado bien o servicio&rdquo;.</span
                          >
                        </li>
                      </ol>
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >Queda expresamente convenido que, en virtud de las
                          disposiciones establecidas precedentemente, as&iacute;
                          como lo dispuesto en el Art&iacute;culo 106,
                          P&aacute;rrafo IV de la Ley General de
                          Protecci&oacute;n de los Derechos del Consumidor o Ley
                          358-05, el proveedor es el &uacute;nico responsable de
                          prestar el servicio al usuario y todas las
                          consecuencias derivadas de este servicio. En ese
                          sentido, queda pactado que el servicio que
                          &ldquo;Marido-en-alquiler.com&rdquo; brindar&aacute; a
                          los usuarios se circunscribe &uacute;nica y
                          exclusivamente a proveer todos los canales de
                          informaci&oacute;n, publicidad y medios de pago para
                          que se efect&uacute;en las compraventas de las ofertas
                          que se publican a trav&eacute;s del portal.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Quienes Somos - Antecedentes</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >&ldquo;Marido-en-alquiler.com&rdquo; nace en junio
                          del 2011 como una propuesta innovadora en el mercado
                          de comercio electr&oacute;nico en la Rep&uacute;blica
                          Dominicana. &ldquo;Marido-en-alquiler.com&rdquo;
                          ofrece diariamente las mejores ofertas en Santo
                          Domingo / Rep&uacute;blica Dominicana con
                          incre&iacute;bles descuentos de hasta un 90% de
                          descuento en restaurantes, spas, ropa, belleza,
                          hoteles, resorts, auto detailing, regalos y mucho
                          m&aacute;s; permitiendo a los usuarios ahorrar,
                          compartir con su grupo de amigos, familiares y
                          disfrutar m&aacute;s de su ciudad.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Derechos de los Usuarios</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >&ldquo;Marido-en-alquiler.com&rdquo;, sin perjuicio
                          de las dem&aacute;s facultades que le confiere la Ley
                          358-05 y el derecho com&uacute;n, garantiza a los
                          usuarios los siguientes derechos:&nbsp;</span
                        >
                      </li>
                      <ol style="list-style-type: lower-roman">
                        <li style="font-weight: 400" aria-level="3">
                          <span style="font-weight: 400"
                            >Las publicaciones contenidas en la p&aacute;gina se
                            encuentran adecuadas a las informaciones
                            suministradas por el proveedor, por lo que
                            &ldquo;Marido-en-alquiler.com&rdquo; se compromete a
                            requerir las mismas utilizando medios de
                            recolecci&oacute;n de informaci&oacute;n que
                            garanticen que el usuario reciba una
                            informaci&oacute;n veraz, clara, oportuna,
                            suficiente, verificable y escrita en idioma
                            espa&ntilde;ol sobre los bienes y servicios
                            ofrecidos que ofrece la oferta, as&iacute; como
                            tambi&eacute;n sobre sus precios,
                            caracter&iacute;sticas, funcionamiento, origen,
                            naturaleza, peso, especificaciones que permita a los
                            consumidores elegir conforme a sus deseos y
                            necesidades, as&iacute; como tambi&eacute;n
                            cualquier riesgo que eventualmente pudieren
                            presentar. La calidad de la oferta es de
                            responsabilidad &uacute;nica y exclusiva del
                            proveedor, por lo que
                            &ldquo;Marido-en-alquiler.com&rdquo; no se hace
                            responsable por la calidad del servicio brindado,
                            aunque se compromete a realizar oportunamente
                            encuestas y levantamiento de
                            retroalimentaci&oacute;n a los fines de garantizar
                            una mejor calidad de las ofertas que se publiquen a
                            trav&eacute;s del portal.</span
                          >
                        </li>
                        <li style="font-weight: 400" aria-level="3">
                          <span style="font-weight: 400"
                            >Las publicaciones contenidas en la p&aacute;gina
                            incluyen los impuestos aplicables o el mensaje del
                            proveedor advirtiendo al usuario cuando los
                            impuestos no est&eacute;n calculados en el precio.
                            En caso de que el impuesto no est&eacute; calculado
                            en el precio de la oferta, la p&aacute;gina se
                            compromete a que se incluya esta observaci&oacute;n
                            en la oferta de manera clara y visible para el
                            usuario.</span
                          >
                        </li>
                        <li style="font-weight: 400" aria-level="3">
                          <span style="font-weight: 400"
                            >En toda promoci&oacute;n u oferta publicada en la
                            p&aacute;gina se informa al usuario sobre las bases
                            de las mismas y el tiempo de su duraci&oacute;n. En
                            ese sentido, &ldquo;Marido-en-alquiler.com&rdquo; se
                            compromete ante el usuario a precisar el plazo en
                            que inicia y termina la oferta, el volumen de los
                            art&iacute;culos que se ofrecen, cantidad de ofertas
                            vendidas, as&iacute; como las condiciones, precios y
                            ventajas de la oferta especial.</span
                          >
                        </li>
                        <li style="font-weight: 400" aria-level="3">
                          <span style="font-weight: 400"
                            >&ldquo;Marido-en-alquiler.com&rdquo; no publica
                            ofertas sobre productos o servicios que generen un
                            cargo autom&aacute;tico en cualquier sistema de
                            d&eacute;bito.</span
                          >
                        </li>
                        <li style="font-weight: 400" aria-level="3">
                          <span style="font-weight: 400"
                            >En ning&uacute;n caso
                            &ldquo;Marido-en-alquiler.com&rdquo;
                            interpretar&aacute; el silencio del usuario como
                            aceptaci&oacute;n a cargo por los productos o
                            servicios que se publican desde la
                            p&aacute;gina.</span
                          >
                        </li>
                      </ol>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Responsabilidad</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >Queda expresamente convenido que
                          &ldquo;Marido-en-alquiler.com&rdquo; es un portal que
                          se encarga de promocionar ofertas de distintos
                          proveedores desde una misma plataforma, a los fines de
                          garantizar un medio r&aacute;pido, f&aacute;cil de
                          usar y seguro para todos los usuarios que ingresen al
                          mismo. En ese sentido y de conformidad a lo que
                          se&ntilde;ala la legislaci&oacute;n vigente, en la Ley
                          No. 358-05 el proveedor de la oferta es el
                          &uacute;nico responsable de la calidad y veracidad de
                          la oferta publicada a trav&eacute;s de
                          &ldquo;Marido-en-alquiler.com&rdquo;. Las
                          reclamaciones y reembolsos a favor de los usuarios se
                          realizar&aacute;n en el marco de lo contenido en los
                          presentes t&eacute;rminos de referencia y se realizan
                          &uacute;nica y exclusivamente a los fines de ofrecer
                          mayor comodidad a los clientes y como intermediario en
                          el pago a favor del beneficiario final, no por
                          responsabilidad en cuanto a la calidad de la oferta y
                          veracidad de la informaci&oacute;n suministrada por el
                          proveedor. Sin embargo, marido-en-alquiler.com
                          realizar&aacute; sus mejores esfuerzos para que el
                          usuario obtenga el mejor servicio o producto o un
                          reembolso de su pago.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Condiciones de Uso</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >&ldquo;Marido-en-alquiler.com&rdquo; se compromete a
                          proveer todas las facilidades a los fines de la
                          adquisici&oacute;n de la oferta en el establecimiento
                          de elecci&oacute;n del usuario, en ese sentido se
                          proporcionar&aacute; la asistencia necesaria en cuanto
                          a la forma y procedimientos para el pago hasta la
                          obtenci&oacute;n del cup&oacute;n que le
                          permitir&aacute; al usuario disfrutar de la oferta
                          adquirida.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Instructivo de Uso</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >Para acceder al instructivo de uso de
                          &ldquo;Marido-en-alquiler.com&rdquo; favor acceder al
                          link que se describe a continuaci&oacute;n:
                          https://www.marido-en-alquiler.com/page/faq</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Uso Apropiado</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >El usuario acepta que es responsable del uso que haga
                          del servicio de publicidad que ofrece el portal, de
                          las entradas que publique y de las consecuencias
                          derivadas. Adem&aacute;s, acepta utilizar el mismo de
                          acuerdo con las leyes, normas y regulaciones locales,
                          estatales, nacionales e internacionales que resulten
                          aplicables.&nbsp;</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >Con el solo uso de
                          &ldquo;Marido-en-alquiler.com&rdquo; el usuario
                          garantiza que tiene la capacidad legal exigida por las
                          normas para utilizarlo y que est&aacute; dispuesto a
                          cumplir con todos los t&eacute;rminos y las
                          condiciones de uso exigidos en el portal.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Datos de Registro</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >Con el fin de garantizar la seguridad de su cuenta en
                          &ldquo;Marido-en-alquiler.com&rdquo;, el usuario se
                          compromete a proporcionar informaci&oacute;n exacta,
                          completa y actualizada de los datos de registro,
                          as&iacute; como mantener la seguridad de su
                          contrase&ntilde;a e identificaci&oacute;n, siendo de
                          su exclusiva responsabilidad el empleo de la cuenta
                          para cualquier acci&oacute;n que se ejecute desde
                          ella.</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >El usuario, por el solo hecho de su registro en
                          &ldquo;Marido-en-alquiler.com&rdquo;, acepta recibir
                          publicidad, notificaciones y correos
                          electr&oacute;nicos respecto de los productos y
                          servicios que se publican desde la
                          p&aacute;gina.</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >En caso de que el usuario desee no recibir correos de
                          publicidad de &ldquo;Marido-en-alquiler.com&rdquo;,
                          deber enviar un correo electr&oacute;nico a:
                          <a
                            href="/cdn-cgi/l/email-protection"
                            class="__cf_email__"
                            data-cfemail="d6b5b9b8a2b7b5a2b996bbb3b1a3a5a2b7f8b2b9"
                            >[email&#160;protected]</a
                          >
                          con el texto: &ldquo;no deseo recibir
                          publicidad&rdquo; o en su defecto en la opci&oacute;n
                          &ldquo;Mi Cuenta&rdquo; deber&aacute; desmarcar todas
                          las opciones por marca.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">
                    Contenido Preestablecido en el Portal
                  </div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >Todo el contenido disponible en
                          &ldquo;Marido-en-alquiler.com&rdquo;, incluyendo
                          dise&ntilde;os, texto, gr&aacute;ficas, cuadros,
                          video, informaci&oacute;n, usos, software,
                          m&uacute;sica, sonido y otros archivos, y su
                          selecci&oacute;n y arreglo, es propiedad exclusiva de
                          Target Innovations S.R.L, de sus filiales o de sus
                          licenciantes o comercios afiliados a
                          marido-en-alquiler.com. Ning&uacute;n contenido en el
                          portal puede ser modificado, copiado, distribuido,
                          enmarcado, reproducido, republicado, descargado,
                          mostrado, fijado, transmitido, o vendido en cualquier
                          forma o por cualquier medio, en todo o en parte, son
                          el permiso previo por escrito de Suncard Payment S
                          R.L.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Contenido de los Usuarios</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >El usuario ser&aacute; enteramente responsable de las
                          fotos, perfiles, mensajes, notas, texto,
                          informaci&oacute;n, m&uacute;sica, video, anuncios,
                          listas y dem&aacute;s contenido que cargue, publique o
                          muestre.</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >Al publicar contenido en
                          &ldquo;Marido-en-alquiler.com&rdquo;, el usuario
                          autoriza a Target Innovations S.R.L a realizar las
                          copias del mismo que se estimen necesarias para
                          facilitar la publicaci&oacute;n y el almacenamiento
                          del Contenido de Usuario en el portal. As&iacute;
                          mismo, al publicar el Contenido de Usuario en
                          cualquier parte de
                          &ldquo;Marido-en-alquiler.com&rdquo;, el usuario
                          otorga a Target Innovations S.R.L una licencia
                          irrevocable, perpetua, no exclusiva, transferible y
                          mundial (con derecho de sub-licencia) para usar,
                          copiar, reproducir p&uacute;blicamente, mostrar
                          p&uacute;blicamente, reformatear, traducir, obtener
                          extractos (totales o parciales) y distribuir dicho
                          Contenido de Usuario para cualquier fin, ya sea
                          comercial, publicitario o de otro tipo, en
                          relaci&oacute;n con el Sitio o la promoci&oacute;n del
                          mismo, para preparar trabajos derivados de dicho
                          Contenido de Usuario o incorporarlo a otros trabajos,
                          y para otorgar y autorizar sub-licencias de lo
                          anterior, que ser&aacute; extensiva incluso
                          despu&eacute;s de haber sido retirado de
                          &ldquo;Marido-en-alquiler.com&rdquo; por el usuario.
                          La licencia mencionada no concede la propiedad sobre
                          el contenido, raz&oacute;n por la cual el Usuario
                          conserva la titularidad exclusiva de todo su Contenido
                          de Usuario y cualesquiera derechos de propiedad
                          intelectual o autor vinculados al mismo.</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >El usuario podr&aacute; retirar su Contenido de
                          Usuario de &ldquo;Marido-en-alquiler.com&rdquo; en
                          cualquier momento.&nbsp; Adicionalmente, Suncard
                          Payment S.R.L se reserva el derecho de borrar, editar
                          y/o modificar los comentarios y/o informaci&oacute;n
                          publicada en &ldquo;Marido-en-alquiler.com&rdquo; por
                          el usuario, sin expresi&oacute;n de causa, cuando
                          &eacute;sta afecte la moral, las buenas costumbres o
                          los intereses, reputaci&oacute;n y/o buen nombre de
                          Target Innovations S.R.L o
                          &ldquo;Marido-en-alquiler.com&rdquo;.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Marcas Registradas</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >La marca registrada
                          &ldquo;Marido-en-alquiler.com&rdquo;, as&iacute; como
                          todas las dem&aacute;s que se pudieran incluir en este
                          portal, sus gr&aacute;ficas, logos, dise&ntilde;os e
                          iconos de bot&oacute;n, son bienes de propiedad de
                          Target Innovations S.R.L, de sus filiales o de sus
                          licenciantes. Estos signos no pueden ser usados en
                          todo o en parte de otras marcas, nombres de dominio, o
                          con alguna conexi&oacute;n con productos o servicios
                          de tal manera que pueda llegar a causar
                          confusi&oacute;n en el p&uacute;blico, as&iacute;
                          mismo no pueden ser copiados, imitados, o usados, en
                          todo o en parte, sin la autorizaci&oacute;n previa y
                          expresa correspondiente.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Políticas de seguridad.</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >La plataforma Marido-en-alquiler.com opera bajo los
                          m&aacute;s altos est&aacute;ndares de seguridad para
                          realizar transacciones econ&oacute;micas a
                          trav&eacute;s de su p&aacute;gina de internet
                          Marido-en-alquiler.com, as&iacute; como para proteger
                          la integridad y privacidad de los datos personales de
                          sus usuarios, los cuales nunca ser&aacute;n
                          compartidos con un tercero sin previa
                          autorizaci&oacute;n por escrito del usuario.</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >La p&aacute;gina de internet Marido-en-alquiler.com
                          almacenar&aacute; las informaciones de tarjeta de
                          cr&eacute;dito o d&eacute;bito de los usuarios de la
                          plataforma Marido-en-alquiler.com, pues se
                          utilizar&aacute; un procesador de pago externo para
                          realizar cada proceso de compraventa entre los
                          usuarios y los proveedores. Estos procesadores de pago
                          podr&aacute;n tener acceso a la informaci&oacute;n
                          personal estrictamente necesaria para completar el
                          proceso de compraventa y de conformidad con la
                          pol&iacute;tica de privacidad, por lo que no
                          podr&aacute;n utilizar dicha informaci&oacute;n para
                          ning&uacute;n otro fin.</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >Para mantener la seguridad de la informaci&oacute;n
                          personal de nuestros usuarios, esta se
                          transmitir&aacute; a trav&eacute;s del servidor seguro
                          Secure Socket Layer (SSL)y ser&aacute; encriptada en
                          nuestra pasarela de pago.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">
                    Actuaciones y conducta del usuario.
                  </div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >El usuario garantiza que no utilizara ni
                          compartir&aacute; ning&uacute;n material que infrinja
                          derechos de terceros, derechos de autor, derechos
                          sobre marcas registradas ni ning&uacute;n otro
                          derecho, ni contendr&aacute; material difamatorio o
                          ilegal en la p&aacute;gina de internet
                          Marido-en-alquiler.com, someti&eacute;ndose a las
                          consecuencias legales que sus actos pudieran generar,
                          sin perjuicio del derecho de Target Innovations S.R.L.
                          de reclamar el pago de da&ntilde;os y perjuicios y de
                          retirar dicho material de la p&aacute;gina y
                          aplicaci&oacute;n m&oacute;vil.El usuario tampoco
                          podr&aacute; usar la p&aacute;gina de internet
                          Marido-en-alquiler.com, ni los servicios en ellas
                          ofrecidos, para:</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >Recopilar direcciones de correo electr&oacute;nico u
                          otra informaci&oacute;n de contacto de otros usuarios
                          de la p&aacute;gina de internet
                          Marido-en-alquiler.com, con el objetivo de enviar
                          correos electr&oacute;nicos no solicitados u otras
                          comunicaciones de cualquier &iacute;ndole.</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="2">
                        <span style="font-weight: 400"
                          >Usar la p&aacute;gina de internet
                          Marido-en-alquiler.com de manera il&iacute;cita o
                          ilegal o que de cualquier otra manera pudiera, directa
                          o indirectamente, da&ntilde;ar, incapacitar,
                          sobrecargar o perjudicar su desempe&ntilde;o o afectar
                          de cualquier manera a Target Innovations S.R.L.
                          Cargar, transmitir, compartir, almacenar o hacer
                          disponible cualquier contenido que se considere
                          da&ntilde;oso, amenazante, ilegal, difamatorio,
                          abusivo, vulgar, obsceno, fraudulento, invasivo de
                          intimidad, discriminatorio o de otra manera
                          desagradable.Imitar a cualquier persona o entidad, o
                          falsamente declarar v&iacute;nculos con cualquier
                          persona o entidad, para recibir alg&uacute;n beneficio
                          de la plataforma Marido-en-alquiler.com de Suncard
                          Payment S.R.L.Cargar, transmitir, compartir, almacenar
                          o de cualquier otra manera hacer p&uacute;blicamente
                          disponible en la p&aacute;gina de internet
                          Marido-en-alquiler.com informaci&oacute;n privada de
                          cualquier tercero o usuario, incluyendo nombres,
                          direcciones, n&uacute;meros de tel&eacute;fono,
                          direcciones de correo electr&oacute;nico y
                          n&uacute;meros de la tarjeta de cr&eacute;dito o
                          d&eacute;bito. Intimidar o acosar a otros
                          usuarios.Crear una identidad falsa en la
                          p&aacute;gina.Cargar, transmitir, compartir, almacenar
                          o de cualquier otra manera hacer disponible un
                          contenido que restrinja o inhiba a cualquier tercero
                          de usar o disfrutar la p&aacute;gina de internet
                          Marido-en-alquiler.com, o que pueda exponer a Suncard
                          Payment S.R.L. o a sus usuarios a cualquier
                          da&ntilde;o o responsabilidad de cualquier tipo.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Políticas de entrega</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="3">
                        <span style="font-weight: 400"
                          >La pol&iacute;tica de entrega de la plataforma
                          Marido-en-alquiler.com es la siguiente:Las
                          transacciones realizadas a trav&eacute;s de la
                          p&aacute;gina de internet marido-en-alquiler.com
                          ser&aacute;n exclusivamente en pesos dominicanos (RD$)
                          y dolar estadounidense (USD$). El impuesto aplicable
                          (ITBIS) est&aacute; incluido en el precio final de
                          venta y se ver&aacute; reflejado en la factura final a
                          emitirse en favor del usuario.</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="3">
                        <span style="font-weight: 400"
                          >Los cupones que resultan de las transacciones de
                          compraventa de las ofertas promocionadas por la
                          plataforma marido-en-alquiler.com tienen una fecha de
                          canje y de caducidad determinada, debidamente
                          estipulada en cada oferta previo a su compra. Es
                          responsabilidad exclusiva del usuario canjear y
                          utilizar dicho cup&oacute;n en el t&eacute;rmino
                          fijado para su vigencia por el proveedor de los bienes
                          y servicios de que se trate.Cada oferta tiene
                          condiciones espec&iacute;ficas de uso, previamente
                          establecidas por el proveedor y expresamente indicadas
                          por la plataforma marido-en-alquiler.com la
                          p&aacute;gina de internet Marido-en-alquiler.com. Es
                          responsabilidad exclusiva del usuario adquirir y
                          canjear la oferta en los t&eacute;rminos y condiciones
                          especificados por el proveedor.</span
                        >
                      </li>
                      <li style="font-weight: 400" aria-level="1">
                        <span style="font-weight: 400"
                          >Para redimir las ofertas adquiridas v&iacute;a la
                          plataforma marido-en-alquiler.com usuario debe
                          comunicarse previamente con el proveedor y hacer la
                          reservaci&oacute;n o arreglos correspondientes de
                          lugar, conforme a los t&eacute;rminos y condiciones
                          especificados para el canje de dicha oferta por el
                          proveedor. La informaci&oacute;n de contacto del
                          proveedor estar&aacute; disponible para el usuario en
                          la secci&oacute;n destinada a dicho proveedor en la
                          p&aacute;gina de internet
                          www.marido-en-alquiler.com.Una vez vencido el
                          cup&oacute;n, por causas no atribuibles al proveedor
                          ni a la plataforma Marido-en-alquiler.com, no se
                          aceptan solicitudes de devoluci&oacute;n o
                          cr&eacute;dito ni reclamaciones por parte del
                          usuario.Una vez confirmada la transacci&oacute;n de
                          pago realizada por el usuario en favor del proveedor
                          por la compraventa de determinada oferta, el
                          cup&oacute;n resultante remitido al usuario
                          directamente a su cuenta de correo electr&oacute;nico
                          registrada en la plataforma, y a su cuenta registrada
                          en la plataforma, accesible v&iacute;a la
                          p&aacute;gina de internet Marido-en-alquiler.com.La
                          calidad de las ofertas publicadas y promocionadas en
                          la plataforma Marido-en-alquiler.com, as&iacute; como
                          del servicio final ofrecido por el proveedor o
                          prestador una vez adquirida dicha oferta, es
                          responsabilidad &uacute;nica y exclusiva del proveedor
                          o prestador.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Conducta del Usuario</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="1">
                        <ol>
                          <li style="font-weight: 400" aria-level="2">
                            <span style="font-weight: 400"
                              >Excepto programas publicitarios ofrecidos por
                              Target Innovations S.R.L sobre
                              &ldquo;Marido-en-alquiler.com&rdquo;, el Servicio
                              y el portal est&aacute;n disponibles para su
                              empleo personal, quedando prohibido su uso con
                              fines de lucro por parte del usuario. El usuario
                              garantiza y conviene que ning&uacute;n material
                              transmitido o compartido por &eacute;l
                              violar&aacute;n o infringir&aacute;n derechos de
                              cualquier tercero, incluyendo derechos de autor,
                              marca registrada, intimidad, publicidad u otro
                              derecho de propiedad; as&iacute; como que no
                              contendr&aacute; material difamatorio o ilegal,
                              someti&eacute;ndose a las consecuencias legales
                              que sus actos pudieran generar, sin perjuicio del
                              derecho de Target Innovations S.R.L de reclamar el
                              pago de da&ntilde;os y perjuicios y de retirar
                              dicho material del portal.</span
                            >
                          </li>
                        </ol>
                        <p>
                          <span style="font-weight: 400"
                            >Adem&aacute;s de lo expuesto, el usuario no
                            podr&aacute; usar el Servicio o el portal
                            para:&nbsp;</span
                          >
                        </p>
                        <ul>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >Recoger direcciones de correo electr&oacute;nico
                              u otra informaci&oacute;n de contacto de otros
                              usuarios del portal por el medio
                              electr&oacute;nico u otro para los objetivos de
                              enviar correos electr&oacute;nico no solicitados u
                              otras comunicaciones no solicitadas, es decir
                              marido-en-alquiler no provee ninguna
                              informaci&oacute;n del usuario para ser utilizadas
                              de las formas anteriormente mencionadas;</span
                            >
                          </li>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >Usar el portal en cualquier manera ilegal o en
                              cualquier otra manera que podr&iacute;a
                              da&ntilde;ar, incapacitar, sobrecargar o
                              perjudicar a la misma o a la empresa que ostenta
                              la titularidad de esta marca;</span
                            >
                          </li>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >Cargar, fijar, transmitir, compartir, almacenar o
                              de otra manera hacer disponible cualquier
                              contenido que se considere da&ntilde;ino,
                              amenazante, ilegal, difamatorio, abusivo, vulgar,
                              obsceno, fraudulento, invasivo de intimidad o
                              racialmente, &eacute;tnicamente o de otra manera
                              desagradables;</span
                            >
                          </li>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >Imitar a cualquier persona o entidad, o
                              falsamente declarar v&iacute;nculos con cualquier
                              persona u entidad;</span
                            >
                          </li>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >Cargar, fijar, transmitir, compartir o de otra
                              manera hacer disponible cualquier publicidad no
                              solicitada o no autorizada, materiales
                              promocionales, &ldquo;cadenas de cartas&rdquo; o
                              cualquier otra forma de publicidad;</span
                            >
                          </li>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >Cargar, fijar, transmitir, compartir, almacenar o
                              de otra manera hacer p&uacute;blicamente
                              disponible sobre el portal cualquier
                              informaci&oacute;n privada de cualquier tercero,
                              incluyendo direcciones, n&uacute;meros de
                              tel&eacute;fono, direcciones de correo
                              electr&oacute;nico, n&uacute;meros de la tarjeta
                              de cr&eacute;dito, entre otros;</span
                            >
                          </li>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >Solicitar informaci&oacute;n personal de alguien,
                              o solicitar contrase&ntilde;as o la
                              informaci&oacute;n que identifica personalmente
                              para objetivos comerciales o ilegales;</span
                            >
                          </li>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >Intimidar o acosar a otros usuarios;</span
                            >
                          </li>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >Crear una identidad falsa sobre la p&aacute;gina,
                              publicando a nombre de marido-en-alquiler.com o
                              creando p&aacute;ginas similares con la finalidad
                              de realizar enga&ntilde;os o confusi&oacute;n en
                              los usuarios.</span
                            >
                          </li>
                        </ul>
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">El Contenido del Usuario</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li>
                        <span style="font-weight: 400"
                          >El usuario es el &uacute;nico responsable de las
                          fotos, perfiles, mensajes, apuntes, texto,
                          informaci&oacute;n, m&uacute;sica, video, publicidad,
                          listados, y otro contenido que cargue o publique en
                          &ldquo;Marido-en-alquiler.com&rdquo;. El usuario
                          entiende y acepta que Target Innovations S.R.L puede
                          repasar el portal y puede suprimir o quitar sin aviso
                          previo cualquier Contenido de &eacute;l cuando a su
                          juicio se est&aacute; vulnerando alguna de las reglas
                          contempladas en este documento.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Disputas entre Usuarios</div>
                  <div class="terms-desc">
                    El usuario es el único responsable de las interacciones con
                    otros usuarios de “Marido-en-alquiler.com”. El operador del
                    portal se reserva el derecho, pero no la obligación de
                    mediar en las disputas de los usuarios.
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Terminación</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="1">
                        <span style="font-weight: 400"
                          >Target Innovations S.R.L puede suprimir el perfil y
                          cualquier contenido y/o informaci&oacute;n que el
                          usuario ha fijado en el portal o por cualquier Uso de
                          Plataforma, y/o puede prohibir el acceso al servicio o
                          el portal o cualquier por el uso indebido y malicioso
                          del usuario en cuesti&oacute;n, el uso de la
                          Plataforma en cualquier momento de confirmarse el uso
                          malintencionado de un usuario sera &ldquo;baneado de
                          la plataforma, con o sin aviso previo.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Notificaciones</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="1">
                        <span style="font-weight: 400"
                          >Para todos los efectos derivados de la
                          celebraci&oacute;n de este contrato, las partes fijan
                          su domicilio marido-en-alquiler.com con domicilio que
                          se indica en la cabeza de este documento, y por parte
                          del cliente seg&uacute;n su domicilio; si no tuviera
                          domicilio por ante el tribunal de su residencia en la
                          Rep&uacute;blica Dominicana.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Cláusula Compromisoria</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="1">
                        <span style="font-weight: 400"
                          >Las diferencias o controversias que surjan entre las
                          partes, ser&aacute;n dirimidas por un Tribunal
                          Arbitral, con sede en Rep&uacute;blica Dominicana, que
                          decidir&aacute; en derecho, de acuerdo con la
                          legislaci&oacute;n de este pa&iacute;s. o el usuario
                          podr&aacute; acogerse a la Ley 358-05.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">
                    Servicios Móviles Marido-en-alquiler.com
                  </div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="1">
                        <span style="font-weight: 400"
                          >El usuario podr&aacute; recibir y responder mensajes
                          de Target Innovations S.R.L., as&iacute; como explorar
                          el portal a trav&eacute;s de su tel&eacute;fono
                          m&oacute;vil (WAP m&oacute;vil) y acceder a
                          determinadas caracter&iacute;sticas del portal
                          descargando contenido del mismo, opciones que
                          ser&aacute;n notificadas previamente por el operador
                          del portal.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">Pago de Premios y/o Promociones</div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="1">
                        <span style="font-weight: 400"
                          >Queda expresamente establecido que los premios a que
                          se hagan acreedores los usuarios del portal
                          s&oacute;lo podr&aacute;n hacerse efectivos en
                          Rep&uacute;blica Dominicano y estar&aacute;n sujetos a
                          las leyes de este pa&iacute;s, reglas de tal
                          promoci&oacute;n, depositadas y aprobadas por
                          pro-consumidor como ordena la Resolucion No. 09/2011
                          sobre Rifas, Concursos y sorteos</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">
                    Políticas de Devoluciónes, Reembolsos y Cancelaciones
                  </div>
                  <div class="terms-desc">
                    <ol style="list-style-type: lower-alpha">
                      <li style="font-weight: 400" aria-level="1">
                        <ol>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >&ldquo;Marido-en-alquiler.com&rdquo; es pionera
                              en cuanto al respaldo de sus usuarios en caso de
                              tener una mala experiencia con el proveedor o
                              establecimiento ofertante. Esto as&iacute; a los
                              fines de poder garantizar, en el marco de su
                              funci&oacute;n como mediador, la salvaguarda de
                              los derechos que le confiere la ley a los
                              usuarios. Queda expresamente convenido que, aunque
                              &ldquo;Marido-en-alquiler.com&rdquo; no sea
                              directamente responsable de proveer el servicio
                              contratado, sino de servir de intermediario entre
                              el comprador y el vendedor de la oferta, ha creado
                              un mecanismo que le permite garantizar la
                              satisfacci&oacute;n de los usuarios. Este
                              mecanismo consiste en hacer el pago a los
                              proveedores de las sumas recibidas por concepto de
                              adquisici&oacute;n de las ofertas, luego de la
                              fecha de expiraci&oacute;n del cup&oacute;n; este
                              mecanismo permite que en los casos en que los
                              clientes no hayan recibido conforme a lo
                              se&ntilde;alado en las condiciones de la oferta,
                              &ldquo;Marido-en-alquiler.com&rdquo; pueda retener
                              esta suma y no pagarla al proveedor.</span
                            >
                          </li>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >Queda expresamente convenido que
                              &ldquo;Marido-en-alquiler.com&rdquo; se reserva el
                              derecho de analizar los casos en los que proceda o
                              no un reembolso, atendiendo a que no es el
                              beneficiario final de las sumas pagadas a
                              trav&eacute;s de la p&aacute;gina y a los fines de
                              garantizar el derecho de defensa del proveedor,
                              deber&aacute; confirmar la reclamaci&oacute;n del
                              usuario con el proveedor del servicio.</span
                            >
                          </li>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >Es importante destacar que esta pol&iacute;tica
                              de reembolso est&aacute; sujeta a las condiciones
                              contractuales que rijan el contrato entre
                              &ldquo;Marido-en-alquiler.com&rdquo; y el
                              proveedor.</span
                            >
                          </li>
                        </ol>
                        <br />
                        <ol>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >En ese sentido, el tr&aacute;mite para optar por
                              un reembolso/cancelaci&oacute;n es el
                              siguiente:</span
                            >
                          </li>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >El cliente deber&aacute; enviar un correo a la
                              direcci&oacute;n electr&oacute;nica
                              <a
                                href="/cdn-cgi/l/email-protection"
                                class="__cf_email__"
                                data-cfemail="c3a0acadb7a2a0b7ac83aea6a4b6b0b7a2eda7ac"
                                >[email&#160;protected]</a
                              >
                              explicando los motivos por el que no recibo el
                              servicio/producto, cancelacion de orden o
                              inconformidad con el servicio brindado por el
                              proveedor;</span
                            >
                          </li>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >&ldquo;Marido-en-alquiler.com&rdquo;
                              proceder&aacute; a la investigaci&oacute;n de la
                              reclamaci&oacute;n con el proveedor;</span
                            >
                          </li>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >&ldquo;Marido-en-alquiler.com&rdquo;
                              presentar&aacute; el caso ante el Comit&eacute; de
                              Reclamaciones de Target Innovations S.R.L quien de
                              conformidad a los hechos y alegatos planteados por
                              el usuario y/o proveedor se encargar&aacute; de
                              reembolsar el dinero al adquiriente de la
                              oferta.</span
                            >
                          </li>
                          <li style="font-weight: 400" aria-level="1">
                            <span style="font-weight: 400"
                              >Nuestros usuarios son lo m&aacute;s importante
                              para nosotros, por lo que conocer sobre sus
                              inquietudes, sugerencias y
                              retroalimentaci&oacute;n de las ofertas adquiridas
                              es indispensable para desarrollar pol&iacute;ticas
                              que mejoren los servicios y eficientizar la
                              calidad de los proveedores que se publican a
                              trav&eacute;s del portal.</span
                            >
                          </li>
                        </ol>
                      </li>
                    </ol>
                  </div>
                </div>
                <div class="terms-wrapper">
                  <div class="terms-title">
                    Aceptación de los Términos y Condiciones
                  </div>
                  <div class="terms-desc">
                    <ol>
                      <li>
                        <span style="font-weight: 400"
                          >Conforme a lo dispuesto en el Art. 3, numeral
                          &ldquo;a&rdquo; de la Ley 358-05 la aceptaci&oacute;n
                          es el &ldquo;consentimiento manifestado de la voluntad
                          de contratar por parte del consumidor o usuario, de
                          forma verbal o escrita o mediante el pago del bien o
                          servicio&rdquo;, en ese sentido mediante la compra del
                          cup&oacute;n de su elecci&oacute;n, el usuario acepta
                          los t&eacute;rminos y condiciones de uso de la
                          presente p&aacute;gina.</span
                        >
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "terms-of-use",
  components: {},
  data() {
    return {
      urls: [
        { url: "/", caption: "Inicio", isActive: false, aria: "" },
        {
          url: "/terminos",
          caption: "Términos de Uso",
          isActive: true,
          aria: "page",
        },
      ],
    };
  },
  methods: {},
  computed: {},
  created() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.$emit("child-breadcrumbs-urls", this.urls);
  },
  mounted() {},
};
</script>

<style scoped>
.terms-title {
  color: #fd5631 !important;
  font-weight: bold;
  padding: 5px 5px;
}
</style>
